import { Component } from '@angular/core';
import { MqBrokerModelComponent } from './mq-broker-model/mq-broker-model.component';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { Subject } from 'rxjs';
import { PosHttpService } from '../../../../services/pos.http.service';
import { TeamGroupModelComponent } from '../../team-group/team-group-model/team-group-model.component';
import { MQBroker } from '../../../../modal/entity.modal';

@Component({
  selector: 'app-mq-broker',
  templateUrl: './mq-broker.component.html',
  styleUrl: './mq-broker.component.scss'
})
export class MqBrokerComponent {

  showData = false;
  uiMap = {
    isDataLoaded: false,
  };

  ngOnInit(): void {
		this.loadData();
	}

  mqDataArray : MQBroker []=[]
  constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService, private fnutilservice: FnUtilService, private toaster: FnToasterService) {
   }
  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'hostName',
      description: 'Host Name',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'brokerName',
      description: 'Broker Name',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'jmxConnectorPort',
      description: 'JMX Connector Port',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'jmxDomainName',
      description: 'JMX Domain Name',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isUseJmx',
      description: 'isUseJmx',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'isActive',
      description: 'isActive',
      type: 'string',
      isSortable: true,
    }

  ];

  loadData() {
		this.posHttpSvcs.authGet('v1/ui/loadMQBrokerData', 'loadMQBrokerData').subscribe((resp: any) => {
			if (resp.isError) {
				this.toastr.error('Invalid loadMQBrokerData ⚠️');
				return;
			}
			this.mqDataArray = resp.data;
			this.showData = false;
			this.refreshTableData();
			this.uiMap.isDataLoaded = true;
		});
	}


   addUpdateSave(objectHash: any) {
		this.posHttpSvcs.authPut('v1/ui/saveMQBroker', 'saveMQBroker', objectHash).subscribe(resp => {
			if (resp.isError) {
				this.toastr.error(' MQBroker is not added ⚠️');
				return;
			} else {
				this.toastr.success("added successfully");
        this.loadData();
			}
		})

	}

  updateRowAction(event: MQBroker) {
    const mqModel = this.fnModalSvcs.openCustomModal(MqBrokerModelComponent, {
      data: {
        mqBroker: event
      },
      hasBackdrop: true,
      width: '500px',
    })
    mqModel.afterClosed().subscribe((objectHash) => {
      if (objectHash != undefined) {
        this.addUpdateSave(objectHash);
      }
    });
  }

  deleteRowAction(event: MQBroker) {
    const dialogRef = this.fnModalSvcs.openConfirmModal({
      isConformationMdl: true,
      content: 'Are you sure you want to delete MQBroker ?',
      type: 'danger',
    });
    dialogRef.afterClosed().subscribe(doAction => {
      if (doAction) {
        this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteMQBroker', event.primaryKey, event).subscribe(resp => {
        this.loadData();
        })
      }
    });

  }

  refreshTableData() {
      if (this.config.tableAction.closed) {
        this.config.tableAction = new Subject<TableAction>();
      }
      this.config.tableAction.next({
        data: this.mqDataArray,
        action: TABLE_ACTION_TYPE.REFRESH,
      });
    }


  openActionMdl() {
    const mqModel = this.fnModalSvcs.openCustomModal(MqBrokerModelComponent, {
      data: {
      },
      hasBackdrop: true,
      width: '500px',
    })
     mqModel.afterClosed().subscribe((objectHash) => {
      if (objectHash != undefined) {
        this.addUpdateSave(objectHash);
      }
    });
  }
}
